<ng-container>
  @if (!hideTableTitle) {
    <h3>{{ tableTitle }}</h3>
  }

  <!-- Add New Icon -->
  <div class="table-header d-flex justify-content-between align-items-center w-100 pb-2 pt-2">
    <!-- Left: Breadcrumb -->
    @if (showBreadcrumb) {
      <app-breadcrumb class="breadcrumb-container"></app-breadcrumb>
    }

    <div class="table-actions-container d-flex justify-content-end align-items-center ml-auto" #tableActionsContainer>
      <!-- All Text filter outside -->
      <div class="all-text-filter mr-2">
        <div class="search-wrapper" [attr.data-tour]="pageType ? (pageType?.toLowerCase() + '-search') : 'table-search'">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="allTextFilterValue"
            (ngModelChange)="applyFilter($event, 'all')" (paste)="onAllTextPaste($event)" />
          </div>
        </div>

        <!-- Dynamic buttons -->
        @if (tableActions?.length > -1) {
          @for (tableAction of tableActions; track tableAction; let i = $index) {
            @if (!tableAction.type) {
              <button class="{{ tableAction?.name }} float-right action-button tableActions"
                [attr.data-tour]="tableAction?.iconName === 'plus' ? (pageType?.toLowerCase()?.includes('paper') ? 'add-question-paper-btn' : (pageType?.toLowerCase()?.includes('assess') ? 'add-assessment-btn' : (pageType?.toLowerCase()?.includes('candidate') ? 'add-candidate-btn' : (pageType?.toLowerCase()?.includes('lead') ? 'add-lead-btn' : (pageType?.toLowerCase()?.includes('account') || pageType?.toLowerCase()?.includes('customer') ? 'add-account-btn' : 'add-question-btn'))))) : (tableAction?.iconName === 'download' ? (pageType?.toLowerCase()?.includes('candidate') ? 'cand-download-btn' : (pageType?.toLowerCase()?.includes('lead') ? 'leads-download-btn' : (pageType?.toLowerCase()?.includes('account') || pageType?.toLowerCase()?.includes('customer') ? 'account-download-btn' : 'table-download-btn'))) : (tableAction?.iconName === 'upload' ? (pageType?.toLowerCase()?.includes('candidate') ? 'cand-upload-btn' : (pageType?.toLowerCase()?.includes('lead') ? 'leads-upload-btn' : (pageType?.toLowerCase()?.includes('account') || pageType?.toLowerCase()?.includes('customer') ? 'account-upload-btn' : 'table-upload-btn'))) : null))"
                mat-mini-fab appAccessControl moduleType="{{ accessControlModuleType }}" pageType="{{ accessControlPageType }}"
                matTooltip="{{ tableAction?.iconTooltip }}" matTooltipClass="table-header-tooltip" permissionName="{{ tableAction?.permission }}"
                (click)="tableActionsEmit(tableAction.name)">
                <i class="fas fa-{{ tableAction?.iconName }} fa-2x"></i>
              </button>
            }
            <!-- Dropdown button -->
            @if (tableAction.type === 'dropdown') {
              <div class="dropdown-button">
                <button mat-mini-fab [matMenuTriggerFor]="menu" class="float-right action-button tableActions"
                  matTooltip="{{ tableAction.iconTooltip }}" matTooltipClass="table-header-tooltip">
                  <i class="fas fa-{{ tableAction.iconName }} fa-2x"></i>
                </button>
                <mat-menu #menu="matMenu">
                  @for (opt of tableAction.options; track opt) {
                    <button mat-menu-item
                      (click)="tableActionsEmit(tableAction.name + '-' + opt.value)">
                      <i class="fas fa-{{ opt.icon }} mr-2"></i>
                      <span>{{ opt.label }}</span>
                    </button>
                  }
                </mat-menu>
              </div>
            }
            <!-- Label Filter Button (injected after Add button) -->
            @if (i === 0) {
              <ng-container *ngTemplateOutlet="labelFilterButtonTemplate"></ng-container>
            }
          }
        }

        <!-- Filter Component -->
        @if (isFilterPresent) {
          <div class="filter" [attr.data-tour]="pageType ? (pageType?.toLowerCase() + '-filter-btn') : 'table-filter-btn'">
            <app-filter class="filterbtn" [filterData]="filterAttributes" (onSelect)="onSelect($event)"
            [filteredData]="selectedFilters" [noOfFilters]="keyLength(selectedFilters.filters)"></app-filter>
          </div>
        }
      </div>
    </div>

    <!-- <div class="filters mt-1 mb-1 table-actions-container d-flex justify-content-end align-items-center">
    <div
      class="filter-item d-flex align-items-center mb-1 mr-1"
      *ngFor="let item of selectedFilters.filters | keyvalue; let i = index"
      >
      <div [innerHTML]="getFilter(item.key, item.value) | bold"></div>
      <span
        ><mat-icon (click)="clearFilterItem(item, i)" class="filter-close"
        >close</mat-icon
        ></span
        >
      </div>
    </div> -->


    @if (isdatePicker && !isFilterPresent) {
      <mat-form-field appearance="fill" class="float-right" [ngClass]="{ 'col-lg-3': isdatePicker && isFilterable }">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="range">
          <input matStartDate formControlName="start" placeholder="Start date" #dateRangeStart (dateChange)="filters()" />
          <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="filters()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matPrefix [for]="dateRangePicker">
        </mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
      </mat-form-field>
    }
    <!-- Filter
    <ng-container *ngIf="isFilterable && !isFilterPresent">
      <mat-form-field
        class="float-right"
        [ngClass]="{ 'col-lg-2': isdatePicker && isFilterable }"
        >
        <mat-label>Table Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Type to Filter Any"
          />
        </mat-form-field>
      </ng-container>-->

      <!-- Table -->
      <div class="table-wrapper" [attr.data-tour]="pageType ? (pageType?.toLowerCase() + '-table') : 'custom-table'">
        @if (moduleType === 'questions' || pageType === 'question banks') {
          <div class="selection-indicator" style="font-size: 12px; margin-bottom: 4px; color: #555; display:flex; gap:10px; align-items:center;">
            @if (selectedCount > 0) {
              <span>{{ selectedCount }} question{{ selectedCount === 1 ? '' : 's' }} selected across pages</span>
            }
            @if (selectAllMode === 'page') {
              <span>(“Select All” applies to current page )</span>
            }
          </div>
        }
        <table mat-table [dataSource]="tableDataSource" matSort (matSortChange)="sortTable($event)" matSortDisableClear
          matSortActive="S.No." matSortDirection="asc" matTableExporter #exporter="matTableExporter"
          [hiddenColumns]="hiddenColumns" class="auto-table" [trackBy]="trackByQuestionId">
          <!-- action column -->
          @for (tableColumn of tableColumns; track tableColumn; let indexOfelement = $index; let isLast = $last) {
            <ng-container
              [matColumnDef]="tableColumn.name">
              <!-- Checkbox Column -->
              @if (tableColumn?.select) {
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="onClickCheckboxItem($event, row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              }
              @if (tableColumn?.singleSelect) {
                <td mat-cell *matCellDef="let row">
                  <mat-radio-button class="example-radio-button" (change)="radioButtonHandler(row)">
                  </mat-radio-button>
                </td>
              }
              <!-- if sortable column header -->
              @if (tableColumn.isSortable && !['s.no.', 'tags', 'attributes'].includes(tableColumn.name.toLowerCase())) {
  <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.name" [arrowPosition]="
    tableColumn.position === 'right' ? 'before' : 'after'
  " [class.last-column]="isLast">
                  @if (tableColumn.name !== 'Actions') {
                    <span>{{ tableColumn.name }}</span>
                  }
                  <!-- Settings button at the end of last column -->
                  @if (isLast) {
                    <button mat-icon-button (click)="toggleTreeDropdown()" class="settings-btn"
                      matTooltip="Configure Columns" matTooltipPosition="above" matTooltipClass="table-header-tooltip">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 27 27" fill="none">
                        <path
                          d="M10.4063 24.75L9.95635 21.15C9.7126 21.0563 9.48291 20.9438 9.26728 20.8125C9.05166 20.6812 8.84072 20.5406 8.63447 20.3906L5.2876 21.7969L2.19385 16.4531L5.09072 14.2594C5.07197 14.1281 5.0626 14.0016 5.0626 13.8797V13.1203C5.0626 12.9984 5.07197 12.8719 5.09072 12.7406L2.19385 10.5469L5.2876 5.20312L8.63447 6.60938C8.84072 6.45937 9.05635 6.31875 9.28135 6.1875C9.50635 6.05625 9.73135 5.94375 9.95635 5.85L10.4063 2.25H16.5938L17.0438 5.85C17.2876 5.94375 17.5173 6.05625 17.7329 6.1875C17.9485 6.31875 18.1595 6.45937 18.3657 6.60938L21.7126 5.20312L24.8063 10.5469L21.9095 12.7406C21.9282 12.8719 21.9376 12.9984 21.9376 13.1203V13.8797C21.9376 14.0016 21.9188 14.1281 21.8813 14.2594L24.7782 16.4531L21.6845 21.7969L18.3657 20.3906C18.1595 20.5406 17.9438 20.6812 17.7188 20.8125C17.4938 20.9438 17.2688 21.0563 17.0438 21.15L16.5938 24.75H10.4063ZM13.5563 17.4375C14.6438 17.4375 15.572 17.0531 16.3407 16.2844C17.1095 15.5156 17.4938 14.5875 17.4938 13.5C17.4938 12.4125 17.1095 11.4844 16.3407 10.7156C15.572 9.94688 14.6438 9.5625 13.5563 9.5625C12.4501 9.5625 11.5173 9.94688 10.7579 10.7156C9.99854 11.4844 9.61885 12.4125 9.61885 13.5C9.61885 14.5875 9.99854 15.5156 10.7579 16.2844C11.5173 17.0531 12.4501 17.4375 13.5563 17.4375Z"
                          fill="#1E1E1E" />
                        </svg>
                      </button>
                    }
                  </th>
                } @else {
                  <th mat-header-cell *matHeaderCellDef [class.text-right]="tableColumn.position == 'right'"
                    [class.last-column]="isLast">
                    @if (tableColumn.name !== 'Actions') {
                      <span>{{ tableColumn.name }}</span>
                    }
                    <!-- Settings button at the end of last column -->
                    @if (isLast) {
                      <button mat-icon-button (click)="toggleTreeDropdown()" class="settings-btn"
                        matTooltip="Configure Columns" matTooltipPosition="below" matTooltipClass="table-header-tooltip">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 27 27" fill="none">
                          <path
                            d="M10.4063 24.75L9.95635 21.15C9.7126 21.0563 9.48291 20.9438 9.26728 20.8125C9.05166 20.6812 8.84072 20.5406 8.63447 20.3906L5.2876 21.7969L2.19385 16.4531L5.09072 14.2594C5.07197 14.1281 5.0626 14.0016 5.0626 13.8797V13.1203C5.0626 12.9984 5.07197 12.8719 5.09072 12.7406L2.19385 10.5469L5.2876 5.20312L8.63447 6.60938C8.84072 6.45937 9.05635 6.31875 9.28135 6.1875C9.50635 6.05625 9.73135 5.94375 9.95635 5.85L10.4063 2.25H16.5938L17.0438 5.85C17.2876 5.94375 17.5173 6.05625 17.7329 6.1875C17.9485 6.31875 18.1595 6.45937 18.3657 6.60938L21.7126 5.20312L24.8063 10.5469L21.9095 12.7406C21.9282 12.8719 21.9376 12.9984 21.9376 13.1203V13.8797C21.9376 14.0016 21.9188 14.1281 21.8813 14.2594L24.7782 16.4531L21.6845 21.7969L18.3657 20.3906C18.1595 20.5406 17.9438 20.6812 17.7188 20.8125C17.4938 20.9438 17.2688 21.0563 17.0438 21.15L16.5938 24.75H10.4063ZM13.5563 17.4375C14.6438 17.4375 15.572 17.0531 16.3407 16.2844C17.1095 15.5156 17.4938 14.5875 17.4938 13.5C17.4938 12.4125 17.1095 11.4844 16.3407 10.7156C15.572 9.94688 14.6438 9.5625 13.5563 9.5625C12.4501 9.5625 11.5173 9.94688 10.7579 10.7156C9.99854 11.4844 9.61885 12.4125 9.61885 13.5C9.61885 14.5875 9.99854 15.5156 10.7579 16.2844C11.5173 17.0531 12.4501 17.4375 13.5563 17.4375Z"
                            fill="#1E1E1E" />
                          </svg>
                        </button>
                      }
                    </th>
                  }
                  <!-- else not sortable -->
                  @switch (tableColumn.type) {
                    <!-- Add sequence case -->
                    @case ('sequence') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        {{ (matPaginator?.pageIndex || 0) * (matPaginator?.pageSize || 0) + tableIndex + 1 }}
                      </td>
                    }
                    <!-- Default case should handle both sequence type and sno dataKey -->
                    @default {
                      <td mat-cell *matCellDef="let element; let tableIndex = index"
                        [class.text-right]="tableColumn.position == 'right'"
              [title]="element | dataPropertyGetter : tableColumn.dataKey" [innerHTML]="
                (tableColumn.dataKey === 'sno' || tableColumn.type === 'sequence') && !element[tableColumn.dataKey]
                  ? (matPaginator?.pageIndex || 0) * (matPaginator?.pageSize || 0) + tableIndex + 1
                  : (element
                    | dataPropertyGetter : tableColumn.dataKey
                    | highlightSearch : searchedString)
              "></td>
                    }
                    @case ('toogle') {
                      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'">
                        <div #statusAccess="appAccessControl" appAccessControl moduleType="{{ accessControlModuleType }}" pageType="{{ accessControlPageType }}"
                          permissionName="{{ tableColumn?.permission }}">
                          @if (tableColumn?.conditionalNaming) {
                  <mat-slide-toggle [checked]="
                    tableColumn?.conditionalNaming[
                      (element | dataPropertyGetter : tableColumn.dataKey)
                    ]?.checked
                  " (change)="toogleEmitterClick($event, element, tableColumn)" [disabled]="
                    tableColumn?.conditionalNaming[
                      (element | dataPropertyGetter : tableColumn.dataKey)
                    ]?.disabled || statusAccess.isDenied
                  ">{{
                              tableColumn?.conditionalNaming[
                              (element | dataPropertyGetter : tableColumn.dataKey)
                              ]?.name
                            }}</mat-slide-toggle>
                          } @else {
                            <mat-slide-toggle [checked]="element | dataPropertyGetter : tableColumn.dataKey"
                              [disabled]="statusAccess.isDenied"
                            (change)="toogleEmitterClick($event, element, tableColumn)">Active</mat-slide-toggle>
                          }
                        </div>
                      </td>
                    }
                    @case ('actions') {
                      <td mat-cell *matCellDef="let element">
                        @for (rowElement of tableColumn.rowActions; track rowElement) {
                <ng-template *ngTemplateOutlet="
                  actionsTemplate;
                  context: { element: element, rowElement: rowElement }
                "></ng-template>
                        }
                      </td>
                    }
                    @case ('threeDotActions') {
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="menu icon">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="action-grid-menu" [overlapTrigger]="true" [hasBackdrop]="true"
                          [xPosition]="'after'" [yPosition]="'below'" (closed)="onMenuClosed()">
                          <div class="action-grid-container">
                            @for (rowElement of (element?.rowActions || tableColumn.rowActions); track rowElement; let i = $index) {
                              <button mat-icon-button [class.action-disabled]="isDisabled || rowElement?.disabled" class="action-grid-item {{ rowElement?.name }}"
                                [matTooltip]="rowElement?.iconTooltip + (isDisabled || rowElement?.disabled ? ' (Not Access)' : '')"
                                [matTooltipClass]="isDisabled || rowElement?.disabled ? 'action-tooltip disabled-tooltip' : 'action-tooltip'"
                                appAccessControl moduleType="{{ accessControlModuleType }}" pageType="{{ accessControlPageType }}"
                                permissionName="{{ rowElement?.permission }}"
                                additionalRowPermission="{{ rowElement?.additionalRowPermission }}"
                                conditionalOperator="{{ rowElement?.conditionalOperator }}"
                                [conditionalValue]="rowElement?.conditionalValue" [elementValue]="element"
                                [rowKey]="rowElement?.rowKey"
                                [compareKey]="rowElement?.compareKey"
                                (click)="!isDisabled && !rowElement?.disabled && emitRowAction(rowElement?.name, element)" [disabled]="isDisabled || rowElement?.disabled"
                                [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">
                                <i class="fas fa-{{ rowElement?.iconName }}"></i>
                              </button>
                            }
                          </div>
                        </mat-menu>
                      </td>
                    }
                    @case ('labelDots') {
                      <td mat-cell *matCellDef="let element" style="padding: 8px;">
                        @if (element.labelGroups && element.labelGroups.length > 0) {
                          <div style="display: flex; gap: 6px; align-items: center;">
                            <!-- Show colored dots only if 4 or less labels -->
                            @if (element.labelGroups.length <= 4) {
                              @for (group of element.labelGroups.slice(0, 4); track group) {
                                <span
                                  [style.backgroundColor]="group.color"
                                  [title]="group.rootLabel"
                                  style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; flex-shrink: 0;"
                                ></span>
                              }
                            }
                            <!-- Show single grey dot ONLY if more than 4 labels -->
                            @if (element.labelGroups.length > 4) {
                              <span
                                class="label-dot-more"
                                [style.backgroundColor]="'#888888'"
                                [title]="'Click to view all ' + element.labelGroups.length + ' labels'"
                                style="cursor: pointer; width: 16px; height: 16px; border-radius: 50%; display: inline-block; flex-shrink: 0;"
                                (click)="toggleTableLabelDropdown($event, element.labelGroups)"
                              ></span>
                            }
                          </div>
                        }
                      </td>
                    }
                    @case ('alias') {
                      <!-- column data -->
            <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'" [innerHTML]="
              element
                ? 'Enabled'
                : ('Disabled'
                  | dataPropertyGetter : tableColumn.dataKey
                  | highlightSearch : searchedString)
            "></td>
                    }
                    @case ('countButton') {
                      <!-- column data -->
                      <td mat-cell *matCellDef="let element">
                        <a class="btn btn-success text-white" href="" [routerLink]="null"
                (click)="countButtonClick(tableColumn.name, element)" [innerHTML]="
                element
                  | dataPropertyGetter : tableColumn.dataKey
                  | highlightSearch : searchedString
              ">{{ element.customer_count }}
                        </a>
                      </td>
                    }
                    @case ('currencyCountButton') {
                      <!-- column data -->
                      <td mat-cell *matCellDef="let element">
                        <a class="btn btn-success text-white" href="" [routerLink]="null"
                (click)="countButtonClick(tableColumn.name, element)" [innerHTML]="
                element
                  | dataPropertyGetter : tableColumn.dataKey
                  | currency : 'INR' : 'symbol-narrow'
                  | highlightSearch : searchedString
              ">{{ element.customer_count }}
                        </a>
                      </td>
                    }
                    <!-- Date Filter On top of the results-->
                    @case ('date') {
                      <!-- column data -->
                      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'"
              [title]="element | dataPropertyGetter : tableColumn.dataKey" [innerHTML]="
              element
                | dataPropertyGetter : tableColumn.dataKey
                | date : 'dd-MMM-yyyy'
                | highlightSearch : searchedString
            "></td>
                    }
                    <!-- Currency Filter On top of the results-->
                    @case ('currency') {
                      <!-- column data -->
                      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'"
              [title]="element | dataPropertyGetter : tableColumn.dataKey" [innerHTML]="
              element
                | dataPropertyGetter : tableColumn.dataKey
                | currency : 'INR' : 'symbol-narrow'
                | highlightSearch : searchedString
            "></td>
                    }
                    <!--Table sequence for results-->
                    @case ('eye') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <button mat-mini-fab matTooltip="View Details" (click)="countButtonClick(tableColumn.name, element)">
                          <mat-icon class="matclass">visibility</mat-icon>
                        </button>
                      </td>
                    }
                    @case ('tags') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="d-flex flex-row flex-wrap">
                            @if (getSafeArray(element[tableColumn.dataKey]); as tagItems) {
                              @for (tag of tagItems.slice(0, 2); track tag) {
                                <mat-chip class="mr-2 my-1 py-1 px-2" [ngClass]="{'highlight-current-tag': isCurrentVersionTag(tag, element)}">
                                  {{ getTagDisplayText(tag) }}
                                </mat-chip>
                              }
                              @if (tagItems.length > 2) {
                                <div class="mt-2 show-all" (click)="showAllTags(tagItems, element, tableColumn)"
                                  >
                                  Show all
                                </div>
                              }
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('passPercentage') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="attributes-group">
                            @for (ele of getSafeArray(element[tableColumn.dataKey])?.slice(0, 1); track ele) {
                              <mat-chip class="attributes-chip pass-percentage-chip"
                                [id]="ele.id"
                                [style.background]="getPassPercentageColor(ele.value)"
                                (click)="onPassPercentageClick(ele, element)">
                                {{ ele.key + ":" + ele.value }}
                              </mat-chip>
                            }
                            @if (getSafeArray(element[tableColumn.dataKey])?.length > 1) {
                              <mat-chip class="show-all"
                                (click)="onPassPercentageShowAll(getSafeArray(element[tableColumn.dataKey]), element)"
                                >
                                Show all
                              </mat-chip>
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('tatAnalysis') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="attributes-group">
                            @for (ele of getSafeArray(element[tableColumn.dataKey])?.slice(0, 1); track ele) {
                              <mat-chip class="attributes-chip tat-analysis-chip"
                                [id]="ele.id"
                                [style.background]="getTatAnalysisColor(ele.value)" (click)="onTatAnalysisClick(ele, element)">
                                {{ ele.key + ":" + ele.value }}
                              </mat-chip>
                            }
                            @if (getSafeArray(element[tableColumn.dataKey])?.length > 1) {
                              <mat-chip class="show-all"
                                (click)="onTatAnalysisShowAll(getSafeArray(element[tableColumn.dataKey]), element)"
                                >
                                Show all
                              </mat-chip>
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('attributes') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="attributes-group">
                            @for (
                              ele of (
                              element | dataPropertyGetter : tableColumn.dataKey
                              )?.slice(0, 2)
                              ; track
                              ele) {
                              <mat-chip class="attributes-chip" [id]="ele.id" [matTooltip]="ele.key + ':' + ele.value">
                                {{ ele.key + ":" + ele.value }}
                              </mat-chip>
                            }
                          <mat-chip class="show-all" (click)="showAllAttributes(element[tableColumn.dataKey], tableColumn.name)">                                 Show all
                            </mat-chip>
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('custom_attr') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="d-flex flex-row flex-wrap">
                            @for (
                              ele of (
                              element | dataPropertyGetter : tableColumn.dataKey
                              ).slice(0, 2)
                              ; track
                              ele) {
                              <mat-chip class="mr-2 my-1 py-1 px-2" (click)="showAllAttributes(element.formattedTags)">
                                {{ ele }}
                              </mat-chip>
                            }
                            @if (
                              (element | dataPropertyGetter : tableColumn.dataKey)
                              .length > 2
                              ) {
                              <div class="mt-2 show-all" (click)="showAllAttributes(element.formattedTags)">
                                Show all
                              </div>
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('qpv_labels') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="d-flex flex-row flex-wrap align-items-center">
                            @for (
                              name of getQpvLabelNames(element.label).slice(0, 2)
                              ; track
                              name) {
                              <mat-chip class="mr-2 my-1 py-1 px-2" (click)="showQpvLabelsPopup(element)">
                                {{ name }}
                              </mat-chip>
                            }
                            @if (
                              getQpvLabelNames(element.label).length > 2
                              ) {
                              <div class="mt-1 show-all" (click)="showQpvLabelsPopup(element)" style="cursor: pointer; color: #007bff; font-weight: 500; font-size: 13px; margin-left: 4px;">
                                Show all
                              </div>
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('labelDots') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <!-- Debug log -->
                        <span style="display: none;">{{ element.labelGroups | json }}</span>
                        @if (element.labelGroups && element.labelGroups.length > 0) {
                          <div style="display: flex; gap: 6px; align-items: center;">
                            <!-- Show colored dots only if 3 or less labels -->
                            @if (element.labelGroups.length <= 3) {
                              @for (group of element.labelGroups.slice(0, 3); track group) {
                                <span
                                  [style.backgroundColor]="group.color"
                                  [title]="group.rootLabel"
                                  style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; flex-shrink: 0;"
                                ></span>
                              }
                            }
                            <!-- Show single grey dot ONLY if more than 3 labels -->
                            @if (element.labelGroups.length > 3) {
                              <span
                                class="label-dot-more"
                                [style.backgroundColor]="'#888888'"
                                [title]="'Click to view all ' + element.labelGroups.length + ' labels'"
                                style="cursor: pointer; width: 16px; height: 16px; border-radius: 50%; display: inline-block; flex-shrink: 0;"
                                (click)="toggleTableLabelDropdown($event, element.labelGroups)"(click)="toggleTableLabelDropdown($event, element.labelGroups)"
                              ></span>
                            }
                          </div>
                        }
                      </td>
                    }
                    @case ('attachmentsLink') {
                      <td mat-cell *matCellDef="let element">
                        @if (element.attachments && element.attachments.length > 0) {
                          <div class="show-all" style="text-decoration: underline; cursor: pointer; color: #495057;" (click)="showAllTags(element.attachments)">
                            Show all
                          </div>
                        } @else {
                          <span>-</span>
                        }
                      </td>
                    }
                    @case ('actionTags') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index">
                        <mat-chip-listbox aria-label="td-tags">
                          <div class="d-flex flex-row flex-wrap">
                            @for (
                              ele of (
                              element | dataPropertyGetter : tableColumn.dataKey
                              ).slice(0, 3)
                              ; track
                              ele) {
                              <mat-chip class="mr-2 my-1 py-1 px-2" (click)="emitActionTag(ele)">
                                <mat-icon class="attachment"> attach_file</mat-icon>{{ ele }}
                              </mat-chip>
                            }
                            @if (
                              (element | dataPropertyGetter : tableColumn.dataKey)
                              .length >= 3
                              ) {
                              <div class="mt-2 show-all" (click)="showAllTags(element.attachments)">
                                Show all
                              </div>
                            }
                          </div>
                        </mat-chip-listbox>
                      </td>
                    }
                    @case ('rich_text') {
                      <td mat-cell *matCellDef="let element; let tableIndex = index"
                        [class.text-right]="tableColumn.position == 'right'"
                        [title]="getFullText(element | dataPropertyGetter : tableColumn.dataKey)">
                        <div class="question-text-container" (click)="openModal(element)">
                          @if (
                            (element | dataPropertyGetter : tableColumn.dataKey) ===
                            NO_PREVIEW
                            ) {
                            <span class="no-preview-text">{{ NO_PREVIEW }}</span>
                          }
                          @if ((element | dataPropertyGetter : tableColumn.dataKey) !== NO_PREVIEW) {
                            <!-- Truncated text with ellipsis -->
                            <div class="hover-wrapper rich-text-wrapper">
                              <div class="question-text-content rich-text-content"
            [innerHTML]="
              (moduleType === 'questions' || pageType === 'question banks')
                ? getCleanRichText(element[tableColumn.dataKey])
                : (element | dataPropertyGetter : tableColumn.dataKey)
            ">
                              </div>
                            </div>
                          }
                        </div>
                      </td>
                    }
                    @case ('stakeholder_name') {
                      <td mat-cell *matCellDef="let element" class="custom-text-column">
                        @if (element.stakeholder_groups?.length) {
                          <mat-chip-listbox aria-label="td-tags">
                            <div class="stakeholder-groups">
                              @for (group of element.stakeholder_groups?.slice(0, 2); track group.category) {
                                <div class="stakeholder-group-row">
                                  <span class="stakeholder-category">{{ group.category }}:</span>
                                  <span class="stakeholder-names">{{ group.names?.slice(0, 2)?.join(', ') }}{{ group.names?.length > 2 ? '…' : '' }}</span>
                                </div>
                              }
                              @if (element.stakeholder_groups?.length > 2 || element.stakeholder_groups?.[0]?.names?.length > 2 || element.stakeholder_groups?.[1]?.names?.length > 2) {
                                <mat-chip class="show-all" (click)="showAllStakeholders(element.stakeholder_groups)">
                                  Show all
                                </mat-chip>
                              }
                            </div>
                          </mat-chip-listbox>
                        }
                      </td>
                    }
                    @case ('text') {
                      <td mat-cell *matCellDef="let element"
                        [class.text-right]="tableColumn.position == 'right'"
                        class="custom-text-column">
                        @if (tableColumn.showCloneIndicator) {
                          <span class="text-cell-with-badge">
                            <span class="text-truncate-cell clone-title-truncate"
                              [matTooltip]="getFullText(formatCellText(element[tableColumn.dataKey], tableColumn))"
                              [matTooltipDisabled]="!shouldShowTooltip(element[tableColumn.dataKey])"
                              matTooltipPosition="below"
                              [innerHTML]="(formatCellText(getFormattedText(element[tableColumn.dataKey]), tableColumn) | striphtml | highlightSearch : searchedString)">
                            </span>
                            @if (element[tableColumn.cloneIndicatorKey]) {
                              <span class="clone-indicator-badge"
                                [matTooltip]="'Cloned from: ' + element[tableColumn.cloneIndicatorKey]"
                                matTooltipPosition="above"
                                [matTooltipShowDelay]="0"
                                aria-label="Cloned assessment indicator">
                                <i class="fas fa-clone"></i>
                              </span>
                            }
                          </span>
                        } @else if (isAttachmentColumn(tableColumn) && element[tableColumn.dataKey]) {
                          <span class="text-truncate-cell attachment-link"
                            style="cursor: pointer;"
                            [matTooltip]="getFullText(formatCellText(element[tableColumn.dataKey], tableColumn))"
                            [matTooltipDisabled]="!shouldShowTooltip(element[tableColumn.dataKey])"
                            matTooltipPosition="below"
                            (click)="openAttachmentPreview(element, tableColumn)"
                            [innerHTML]="(formatCellText(getFormattedText(element[tableColumn.dataKey]), tableColumn) | striphtml | highlightSearch : searchedString)">
                          </span>
                        } @else {
                          <span class="text-truncate-cell"
                            [matTooltip]="getFullText(formatCellText(element[tableColumn.dataKey], tableColumn))"
                            [matTooltipDisabled]="!shouldShowTooltip(element[tableColumn.dataKey])"
                            matTooltipPosition="below"
                            [innerHTML]="(formatCellText(getFormattedText(element[tableColumn.dataKey]), tableColumn) | striphtml | highlightSearch : searchedString)">
                          </span>
                        }
                        <!-- Show More button -->
                        @if (tableColumn.alwaysShowMore && getStrippedLength(element[tableColumn.dataKey]) > 0) {
                          <button
                            mat-button class="show-more-btn"
                            (click)="showFullContent(element[tableColumn.dataKey], tableColumn.name)">
                            Show More
                          </button>
                        }
                      </td>
                    }
                  }
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-center py-5" [attr.colspan]="displayedColumns.length">

                  @if (isLoading) {
                    <div class="text-muted">
                      Fetching records...
                    </div>
                  }

                  @if (!isLoading && tableDataSource.data.length === 0) {
                    <div>
                      @if (!!searchedString) {
                        <span>No data matching the filter "{{ searchedString }}"</span>
                      }
                      @if (!searchedString) {
                        <span>No records found!</span>
                      }
                    </div>
                  }

                </td>
              </tr>
              <!-- <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" colspan="3">No records found!</td>
            </tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <!-- Tree dropdown moved outside ngFor -->
        @if (treeDropdownOpen) {
          <div class="tree-dropdown-container" #treeviewContainer>
            <ngx-treeview [config]="treeConfig" [items]="treeDropdownColumns"
            (selectedChange)="onTreeviewCheckedChange($event)"></ngx-treeview>
            <div class="tree-dropdown-actions">
              <button mat-button class="default-btn" (click)="resetToDefaultColumns()"
                matTooltip="Restore the default column set">
                Default
              </button>
              <button mat-button class="confirm-btn" [disabled]="!isColumnsChanged" [ngClass]="{ 'active': isColumnsChanged }"
              (click)="confirmColumnSelection()">Confirm</button>
              <button mat-button class="cancel-btn" (click)="cancelColumnSelection()">Cancel</button>
            </div>
          </div>
        }


        <!-- Pagination -->
        @if (isPageable) {
          <mat-paginator
            [pageSizeOptions]="paginationSizes"
            [pageSize]="defaultPageSize"
            [length]="totalCount"
            (page)="handlePageEvent($event)"
            showFirstLastButtons>
          </mat-paginator>
        }
      </ng-container>

      <!-- Template for Actions Button -->

      <ng-template #actionsTemplate let-element="element" let-rowElement="rowElement">
        <button mat-button class="{{ rowElement?.name }} rowActions" mat-mini-fab appAccessControl
          moduleType="{{ accessControlModuleType }}" pageType="{{ accessControlPageType }}" permissionName="{{ rowElement?.permission }}"
          additionalRowPermission="{{ rowElement?.additionalRowPermission }}"
          conditionalOperator="{{ rowElement?.conditionalOperator }}" [conditionalValue]="rowElement?.conditionalValue"
          [elementValue]="element" matTooltip="{{ rowElement?.iconTooltip }}"
          (click)="emitRowAction(rowElement?.name, element)">
          <i class="fas fa-{{ rowElement?.iconName }} fa-2x"></i>
        </button>
      </ng-template>

      <!-- Show tags modal -->
      <div class="modal fade" #viewAllTagsModal id="viewAllTagsPopup" role="dialog" tabindex="-1" aria-hidden="true" style="z-index: 99999;">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header text-center">
              <h3 id="hdrImageTitle" class="modal-title text">
                @if (isVersionNoColumn) {
                  <span>All Versions</span>
                }
                @if (!isVersionNoColumn && type === 'qpv_labels') {
                  <span>All Labels</span>
                }
                @if (!isVersionNoColumn && type === 'stakeholder_name') {
                  <span>All Stakeholders</span>
                }
                @if (!isVersionNoColumn && type !== 'qpv_labels' && type !== 'stakeholder_name') {
                  <span>All {{ type | titlecase }}</span>
                }
              </h3>
              <button type="button" class="close float-right text" aria-label="Close"
                (click)="$event.stopPropagation(); closeViewAllTagsModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="required">
                      @if (type === 'tags') {
                        <div>
                          @if (!isTableActionTagPresent && !isTagsArray(allTags)) {
                            <div class="d-flex flex-row flex-wrap"
                              >
                              @for (tag of allTags; track tag) {
                                <mat-chip class="mx-2 my-1 py-1 px-2" [ngClass]="{'highlight-current-tag': isCurrentVersionTag(tag, null, true)}">
                                  {{ tag }}
                                </mat-chip>
                              }
                            </div>
                          } @else {
                            @if (isTagsArray(allTags) && !isTableActionTagPresent) {
                              <div class="d-flex flex-row flex-wrap">
                                @for (tag of allTags; track tag) {
                                  <mat-chip class="mx-2 my-1 py-1 px-2">
                                    {{ tag.key }}:{{ tag.value }}
                                  </mat-chip>
                                }
                              </div>
                            }
                            @if (isTableActionTagPresent) {
                              <div class="d-flex flex-row flex-wrap">
                                @for (tag of allTags; track tag) {
                                  <mat-chip class="mx-2 my-1 py-1 px-2" (click)="emitActionTag(tag)">
                                    {{ tag }}
                                  </mat-chip>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                      @if (type === 'qpv_labels') {
                        <div>
                          @if (labelHierarchy && labelHierarchy.length > 0) {
                            <div>
                              <div class="qpv-label-tree">
                                @for (node of labelHierarchy; track node) {
                                  <ng-container *ngTemplateOutlet="treeNodeTmpl; context: { $implicit: node }"></ng-container>
                                }
                              </div>
                            </div>
                          } @else {
                            <div class="text-center py-3" style="color: grey; font-size: 16px;">
                              No labels assigned
                            </div>
                          }
                        </div>
                      }
                      @if (type === 'stakeholder_name') {
                        <div>
                          @if (allTags && allTags.length > 0) {
                            <div class="stakeholder-group-list">
                              @for (group of allTags; track group.category) {
                                <div class="stakeholder-group-block">
                                  <div class="stakeholder-group-title">{{ group.category }}</div>
                                  <div class="d-flex flex-row flex-wrap">
                                    @for (name of group.names; track name) {
                                      <mat-chip class="mx-2 my-1 py-1 px-2">{{ name }}</mat-chip>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="text-center py-3" style="color: grey; font-size: 16px;">
                              No stakeholders added
                            </div>
                          }
                        </div>
                      }
                      @if (type !== 'tags' && type !== 'qpv_labels' && type !== 'stakeholder_name') {
                        <div>
                          @if (allTags && allTags.length > 0) {
                            <div class="attribute-list">
                              @for (tag of allTags; track tag) {
                                <div class="attribute-list-item">
                                  <span class="attribute-list-key">{{ tag.key }}</span>
                                  <span class="attribute-list-value">{{ tag.value }}</span>
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="text-center py-3" style="color: grey; font-size: 16px;">
                              No attributes added
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show attributes modal -->
      <div class="modal fade" id="viewAllAttributesPopup" role="dialog" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header text-center">
              <h3 id="hdrImageTitle" class="modal-title text">All Attributes</h3>
              <button type="button" class="close float-right text" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="required">
                      <div>
                        <div class="d-flex flex-row flex-wrap">
                          @for (attribute of allAttributes; track attribute) {
                            <mat-chip class="mx-2 my-1 py-1 px-2 attributes-chip">
                              {{ attribute.key + ":" + attribute.value }}
                            </mat-chip>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Label Dropdown Popup for Table -->
      @if (showTableLabelDropdownFlag) {
        <div
          id="tableLabeLDropdownPopup"
          [style.top.px]="tableDropdownPosition.top"
          [style.left.px]="tableDropdownPosition.left"
          (click)="$event.stopPropagation()"
          style="position: fixed; background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 4px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); z-index: 1000; padding: 12px; display: flex; gap: 8px; flex-wrap: wrap; width: 115px; max-width: 115px;"
          >
          @for (group of tableRemainningLabels; track group) {
            <span
              [title]="group.rootLabel"
              style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; cursor: pointer; flex-shrink: 0;"
              [style.backgroundColor]="group.color"
            ></span>
          }
        </div>
      }

      <div class="modal fade" id="viewFullContentModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{fullContentTitle}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" [innerHTML]="fullContent"></div>
          </div>
        </div>
      </div>

      <ng-template #treeNodeTmpl let-node>
        <div class="tree-node-wrapper" [style.margin-left.px]="node.level * 24" style="margin-top: 8px; margin-bottom: 8px;">
          <div class="tree-node-content d-flex align-items-center">
            <!-- Expand/Collapse arrow icon -->
            @if (node.children && node.children.length > 0) {
              <span class="tree-node-arrow" (click)="$event.stopPropagation(); toggleNode(node)" style="cursor: pointer; margin-right: 8px; display: inline-flex; align-items: center;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                  {{ node.collapsed ? 'arrow_right' : 'arrow_drop_down' }}
                </mat-icon>
              </span>
            }
            @if (!node.children || node.children.length === 0) {
              <span class="tree-node-arrow-placeholder" style="width: 26px; display: inline-block;"></span>
            }

            <!-- Label name -->
            <span class="tree-node-text" [class.font-weight-bold]="node.level === 0" style="font-size: 14px; color: #333;">
              {{ node.labelName }}
            </span>
          </div>

          <!-- Render children recursively if not collapsed -->
          @if (node.children && node.children.length > 0 && !node.collapsed) {
            <div class="tree-node-children">
              @for (child of node.children; track child) {
                <ng-container *ngTemplateOutlet="treeNodeTmpl; context: { $implicit: child }"></ng-container>
              }
            </div>
          }
        </div>
      </ng-template>